import React, { useEffect } from 'react'
import { Button, Input } from '../../../Components/StyledComponents';
import './CreateStaffCall.scss';
import {cloneDeep} from 'lodash-es';
import { support_language } from '../../../Utils/services';
import { useSelector } from 'react-redux';
import { onTranslation } from '../../../Utils/functions';
import CheckLanguage from '../../../Components/TableOrder/CheckLanguage';

const ModifyStaffCall = ({info, modifyStaffCall}) => {
    const [ name, setName ] = React.useState({})
    const language = useSelector(state => state.tableorder.language);

    useEffect(() => {
        if(typeof info !== 'undefined'){
            setName(cloneDeep(info.Name))
        }
    },[])

    const patch = () => {
        modifyStaffCall(
            info._id.$oid, {
            Name : name,
        })
    }

    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko];
        const trans_value = ['name'];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
    };

    return (
        <div className='create-menu'>
            <div className='row'>
                <p className='label'>직원호출명</p>
                <Input
                    value={name.ko}
                    onChange={(e) => setName({...name, ko: e.target.value})}
                    style={{ width : 347 }}
                    placeholder="예) 숟가락, 젓가락, 물, 컵, 앞치마, 앞접시 등"
                />
            </div>
            <CheckLanguage>
                <div className='btn-row' style={{margin:'16px 0', alignItems:'center'}}>
                    <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                    <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                        자동번역
                    </Button>
                </div>
                
                <div style={{display:'flex', flexDirection:'column', gap: 4, marginTop:8}}>
                    {support_language.map((item, index) => 
                        language[item.value] && <div className="row">
                            <p className="label">{item.text}</p>
                            <Input value={name[item.value]} onChange={(e) => setName({...name, [item.value]: e.target.value})} placeholder="예) 1인분, 300g 등" style={{ width : 278, marginLeft: 16, marginRight: 16, paddingLeft:16, paddingRight:16 }}/>
                        </div>
                    )}
                </div>
            </CheckLanguage>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()} disabled={ name.ko?.trim() === ''}>
                    수정하기
                </Button>
            </div>
        </div>
    )
}

export default ModifyStaffCall;